module.exports = __webpack_public_path__ + "static/media/woman-holding-phone-icon.cef11d2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/woman-holding-phone-icon.png
// module id = 356
// module chunks = 0